import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectReportRequestFailure({ uuid }) {
      const req = getState().find(({ report }) => report.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditProjectReportRequestPending({ uuid }) {
      const req = getState().find(({ report }) => report.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditProjectReportRequestSuccess({ uuid }) {
      const req = getState().find(({ report }) => report.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
